// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__3YUuY","index":"styles_index__3fACE"};